/**
 * Created by andrey on 23.12.2025
 */

Object.assign(AdsLimits.TYPES, {
    ENERGY: "energy",
    ENERGY_1: "energy_1",
    ENERGY_1_SHORT: "energy_short_1",
    ENERGY_2: "energy_2",
    ENERGY_2_SHORT: "energy_short_2",
    ENERGY_3: "energy_3",
    ENERGY_3_SHORT: "energy_short_3",
    ENERGY_4: "energy_4",
    ENERGY_4_SHORT: "energy_short_4",
    ENERGY_5: "energy_5",
    ENERGY_5_SHORT: "energy_short_5"
});